
<template>
  <div class="benchmark-config-editor">
    <b-field class="">
      <b-switch
        v-model="benchmarkEnabled"
        type="is-info">
        Configure this row relative to a benchmark
      </b-switch>
    </b-field>

    <div
      v-if="benchmarkEnabled"
      class="benchmark-inputs">
      <b-field
        class="input-field"
        label="Display this row's values as:">
        <singleselect
          v-model="inputs.difference_type"
          :append-to-body="true"
          :options="resolvedDifferenceTypeOptions"
          :return-as-object="false"
          :enable-search="false"
          label="label"
          track-by="key"
          header-placeholder="Select difference type" />
      </b-field>

      <MeasureConfigEditor
        v-model="inputs.measure_config"
        :errors="childErrors('measure_config', errors)"
        :context="context" />

      <ConditionalFormatEditor
        v-model="conditionalFormat"
        :difference-type="inputs.difference_type"
        :context="context"
        :hide-direction="hideDirection">
        <template #direction>
          <slot name="direction" />
        </template>
      </ConditionalFormatEditor>
    </div>
  </div>
</template>

<script>

  import singleselect from '@/components/ui/singleselect.vue'
  import ModuleConfigMixin from '@/components/reports/config/modules/common/ModuleConfigMixin'
  import MeasureConfigEditor from '@/components/reports/config/modules/common/MeasureConfigEditor'
  import ConditionalFormatEditor from '@/components/reports/config/modules/common/ConditionalFormatEditor'
  import { childErrors as _childErrors } from '@/components/reports/config/common/validation'
  export default {
    name: 'BenchmarkConfigEditor',
    components: {
      ConditionalFormatEditor,
      MeasureConfigEditor,
      singleselect,
    },
    mixins: [
      ModuleConfigMixin,
    ],
    props: {
      errors: {
        type: Array,
        default: () => [],
      },
      // Hide the absolute good/bad control for callers that derive direction
      // elsewhere — the KPI module takes it from the measure. The `direction`
      // slot renders in its place.
      hideDirection: {
        type: Boolean,
        default: false,
      },
      // Extra "Display this row's values as" choices, appended to the
      // standard three.
      extraDifferenceTypeOptions: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {

        defaultValue: null,

        differenceTypeOptions: [
          {
            key: 'none',
            label: 'Original measure with conditional formatting',
          },
          {
            key: 'diff',
            label: 'Difference to benchmark',
          },
          {
            key: 'var',
            label: 'Percentage change from benchmark',
          },
        ],
      }
    },
    computed: {
      resolvedDifferenceTypeOptions () {
        return [
          ...this.differenceTypeOptions,
          ...this.extraDifferenceTypeOptions,
        ]
      },
      benchmarkEnabled: {
        get () {
          return ![ null, undefined, ].includes(this.inputs)
        },
        set (benchmarkEnabled) {
          if (benchmarkEnabled) {
            this.inputs = {
              measure_config: {
                measure: this.context.parentMeasure,
                is_pct_total: false,
                pct_total_dimensions: [],
                comp_filter_type: 'none',
              },
              conditional_format: null,
              difference_type: 'none',
            }
          } else {
            this.inputs = null
          }
        },
      },
      conditionalFormat: {
        get () {
          return this.inputs?.conditional_format || null
        },
        set (conditionalFormat) {
          this.$set(this.inputs, 'conditional_format', conditionalFormat)
        },
      },
    },
    methods: {
      childErrors: _childErrors,
    },
  }
</script>

<style lang="scss" scoped>
.benchmark-inputs {
  margin-top: 30px;
}
</style>
